var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-head'),_c('div',{staticClass:"enterprisecertification minH"},[_c('div',{staticClass:"title"},[_vm._v("企业认证列表")]),_c('enterprise-list',{ref:"child"})],1),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }